module.exports = __webpack_public_path__ + "static/media/imgLogin.467f4b71.png";